<template>
    <ion-header v-if="$store.state.signedIn">
        <ion-toolbar>
            <ion-buttons slot="start">
                <ion-button @click="$router.push({name: 'profile'})">
                    <ion-icon name="contact" slot="icon-only" mode="md" :color="$route.name == 'profile' ? 'primary' : ''"></ion-icon>
                </ion-button>
            </ion-buttons>

            <ion-title><a href="#" @click="$router.push('/')"><ion-img :src="require('@/assets/nimtu_medium.png')" /></a></ion-title>
            <ion-buttons slot="end">
                <!--<ion-button>
                    <ion-icon class="smaller" name="gift" slot="icon-only" mode="md"></ion-icon>
                </ion-button>-->
                <ion-button  @click="$router.push({name: 'alerts'})">
                    <ion-icon class="smaller" name="notifications" slot="icon-only" mode="md" :color="$route.name == 'alerts' ? 'primary' : ''"></ion-icon>
                </ion-button>
            </ion-buttons>
        </ion-toolbar>
    </ion-header>
</template>

<script>
    export default {
        name: "SignedInHeader",
    }
</script>

<style scoped>
    ion-header ion-img {
        padding: .5em;
        height: 3em;
    }

    ion-header ion-button {
        --padding-start: 0 !important;
        --padding-end: 0 !important;
        --padding-top: 0 !important;
        --padding-bottom: 0 !important;
    }

    ion-header ion-icon {
        font-size: 2.2em !important;
        color: #999;
    }

    ion-icon.smaller {
        font-size: 2em !important;
    }
</style>